"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgShieldOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 1.94L4 6.3V16c0 10.58 11.18 14.77 11.66 14.94l.34.12.34-.12C16.82 30.77 28 26.58 28 16V6.3zM26 16c0 8.21-8.21 12.16-10 12.92C14.21 28.16 6 24.21 6 16V7.7l10-3.64L26 7.7z" })));
}
exports.default = SvgShieldOutline;
//# sourceMappingURL=ShieldOutline.js.map